import instance from "../utils/network";

export enum TournamentTicketType {
  EXTERNAL = "external",
  INTERNAL = "internal",
}
export interface TournamentTicketSellerFilterRequest {
  pubId: number;
  page: number;
  limit: number;
  q?: string;
  /** available: 구매가능, unavailable: 구매불가능, expired: 발행정지 */
  type?: "available" | "unavailable" | "expired" | null;
}

export interface TournamentTicketListResponseForSeller {
  list: TournamentTicketResponseForSeller[];
  totalCount: number;
  canBuyCount: number;
  cannotBuyCount: number;
  pubSeed: number;
  pubCarrot: number;
}

export interface TournamentTicketResponseForSeller {
  id: number;
  name: string;
  sellerPrice: number | null; // 교환 가격 (null이면 '-' 표시)
  userPrice: number | null;
  prizeValue: number;
  imageUrl: string;
  hasCount: number; // 펍 보유 수량
  remainCount: number | null; // 남은 수량 (limitCount 없으면 null)
  isSale: boolean; // false → 구매 불가
  isExpired: boolean; // true → 발행 정지
  isLimited: boolean; // 발행 제한 또는 구매 상한 도달
  canBuy: boolean; // 구매 가능 여부
  sellerLimitCount: number | null; // 보유가능수량
  /** 구매 상한 (null = 무제한) */
  buyLimitCount: number | null;
  /** 이 펍 누적 구매 수 */
  buyCount: number;
}

export interface BuyTournamentTicketRequest {
  ticketId: number;
  count: number;
  pubId: number;
}

export interface MemberHasTournamentTicketFilterRequest {
  pubId: number;
  page: number;
  limit: number;
  nickname?: string;
  ticketId?: number;
}
export interface MemberHasTournamentTicketResponse {
  userId: number;
  nickname: string;
  textId: string;
  phoneLast4: string;
  ticketId: number;
  ticketName: string;
  type: TournamentTicketType;
  count: number;
}

export interface MemberHasTournamentTicketListResponse {
  list: MemberHasTournamentTicketResponse[];
  totalCount: number;
  totalHasCount: number; // 총 보유 수량
}

export interface TournamentTicketSimpleResponse {
  id: number;
  name: string;
}

export interface TournamentTicketSimpleListResponse {
  list: TournamentTicketSimpleResponse[];
  totalCount: number;
}

export interface TournamentTicketSellerSimpleFilterRequest {
  pubId: number;
  page: number;
  limit: number;
  q?: string;
}

export interface TournamentTicketSellerLogFilterRequest {
  pubId: number;
  page: number;
  limit: number;
}

export interface SellerTournamentTicketLogResponse {
  createdAt: Date;
  pubName: string;
  nickname: string;
  ticketName: string;
  type: string;
  count: number;
  memo: string;
}

export interface SellerHasTournamentTicketListResponse {
  id: number;
  name: string;
  prizeValue: number;
  count: number;
}

export interface SellerTournamentTicketLogListResponse {
  list: SellerTournamentTicketLogResponse[];
  totalCount: number;
}

export interface TournamentTicketPrizeValueResponse {
  id: number;
  prizeValue: number;
}

export function buyTournamentTicketApi(
  request: BuyTournamentTicketRequest,
): Promise<{ code: number; message: any }> {
  return instance.post(`/seller/tournament-ticket/buy`, request);
}

export function acceptTournamentTicketBuyRequest(
  pubId: number,
  requestId: number,
): Promise<{ code: number; message: any }> {
  return instance.post(
    `/seller/tournament-ticket/buy-request/${requestId}/accept?pubId=${pubId}`,
  );
}

export function rejectTournamentTicketBuyRequest(
  pubId: number,
  requestId: number,
): Promise<{ code: number; message: any }> {
  return instance.post(
    `/seller/tournament-ticket/buy-request/${requestId}/reject?pubId=${pubId}`,
  );
}

export interface TournamentTicketBuyRequestItem {
  id: number;
  pubId: number;
  userId: number;
  nickname: string;
  ticketId: number;
  ticketName: string;
  count: number;
  status: string;
  createdAt: string;
}

export function getTournamentTicketBuyRequests(
  pubId: number,
): Promise<{ list: TournamentTicketBuyRequestItem[] }> {
  return instance.get(`/seller/tournament-ticket/buy-request`, {
    params: { pubId },
  });
}

export function getTournamentTicketPrizeValue(): Promise<
  TournamentTicketPrizeValueResponse[]
> {
  return instance.get(`/seller/tournament-ticket/prize`);
}

export function getTournamentTicketListForSeller(
  request: TournamentTicketSellerFilterRequest,
): Promise<TournamentTicketListResponseForSeller> {
  return instance.get(`/seller/tournament-ticket`, { params: request });
}

export function getMemberHasTournamentTicketList(
  request: MemberHasTournamentTicketFilterRequest,
): Promise<MemberHasTournamentTicketListResponse> {
  return instance.get(`/seller/tournament-ticket/member-has`, {
    params: request,
  });
}

export function getTournamentTicketSimpleList(
  request: TournamentTicketSellerSimpleFilterRequest,
): Promise<TournamentTicketSimpleListResponse> {
  return instance.get(`/seller/tournament-ticket/all`, { params: request });
}

export function getSellerTournamentTicketLogList(
  request: TournamentTicketSellerLogFilterRequest,
): Promise<SellerTournamentTicketLogListResponse> {
  return instance.get(`/seller/tournament-ticket/ticket-log`, {
    params: request,
  });
}

export function getSellerHasTournamentTicketList(
  pubId: number,
): Promise<SellerHasTournamentTicketListResponse[]> {
  return instance.get(`/seller/tournament-ticket/has`, {
    params: { pubId },
  });
}
